import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { Row, Col } from "react-bootstrap";
import { Card, CardBody, CardHeader } from "reactstrap";
import "../../CSS/configuracion.css";
import api from "../../Component/axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
library.add(fab, fas, far);
const MySwal = withReactContent(Swal);

const validateInput = (inputValue) => {
  const nonAlphabetPattern = /^[^a-zA-Z]*$/;
  return nonAlphabetPattern.test(inputValue);
};

const Yeguere = () => {
  const [yegeuereList, setYeguereList] = useState([]);
  const [yeguere, setYeguere] = useState("");
  const token = localStorage.getItem("@Token");

  const getYeguere = () => {
    api
      .get("api/empaque/yegueres/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + token,
        },
      })
      .then((response) => {
        setYeguereList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const inserNewYeguere = () => {
    if (yeguere === "" || validateInput(yeguere)) {
      MySwal.fire({
        icon: "info",
        title: "Favor de llenar todos los campos",
        timer: 1500,
      });
      return;
    }
    api
      .post(
        "api/empaque/yegueres/",
        {
          data: { yeguere: yeguere },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Token " + token,
          },
        }
      )
      .then((response) => {
        MySwal.fire({
          icon: "success",
          title: "Datos guardados",
          showConfirmButton: false,
          timer: 1500,
        });
      })
      .catch((error) => {
        if (error.response.status === 400) {
          MySwal.fire({
            icon: "error",
            title: error.response.data.msg,
          });
        } else {
          MySwal.fire({
            icon: "error",
            title: error,
            text: "Favor de contactar con el equipo de desarrollo para solucionar el problema",
          });
        }
      })
      .finally(() => {
        setYeguere("");
        getYeguere();
      });
  };

  const editYeguere = (id_yeguere) => {
    const yeguere_selected = yegeuereList.find(
      (item) => item.idyeguere === id_yeguere
    );
    MySwal.fire({
      title: "Modificar yeguere",
      input: "text",
      inputAttributes: {
        autocapitalize: "off",
        value: yeguere_selected.yeguere,
      },
      showCancelButton: true,
      confirmButtonText: "Guardar",
      showLoaderOnConfirm: true,
      backdrop: true,
      preConfirm: async (yeguere) => {
        try {
          if (yeguere === "" || validateInput(yeguere)) {
            throw new Error("Favor de llenar los campos");
          }
          const response = await api.put(
            "api/empaque/yegueres/",
            {
              data: {
                idyeguere: id_yeguere,
                yeguere: yeguere,
              },
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + token,
              },
            }
          );
          return response;
        } catch (error) {
          Swal.showValidationMessage(`Error - ${error}`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Datos guardados",
        });
        getYeguere();
      }
    });
  };

  const deleteYeguere = (id_yeguere, estatus) => {
    const action = estatus === 0 ? "activar" : "desactivar";
    const responseText = estatus === 0 ? "activado" : "desactivado";
    MySwal.fire({
      icon: "warning",
      title: `¿Está seguro que desea ${action} el yeguere?`,
      showCancelButton: true,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: estatus === 0 ? "Activar" : "Desactivar",
      confirmButtonColor: estatus === 0 ? "#28a745" : "#dc3545",
      backdrop: true,
      preConfirm: async () => {
        try {
          const response = await api.delete(
            `api/empaque/yegueres/?id_yeguere=${id_yeguere}&estatus=${
              estatus === 1 ? 0 : 1
            }`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Token " + token,
              },
            }
          );
          return response;
        } catch (error) {
          Swal.showValidationMessage(`Error - Algo salio mal`);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        getYeguere();
        MySwal.fire({
          icon: "success",
          title: `Registro ${responseText}`,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  useEffect(() => {
    getYeguere();
  }, []);

  return (
    <Card className="my-2" style={{ height: "90vh" }}>
      <CardHeader style={{ fontWeight: "bold", textAlign: "center" }}>
        Nuevo yeguere
      </CardHeader>
      <CardBody>
        <Row>
          <Col md={3} xs={12} sm={12} lg={3}>
            <input
              className="form-control"
              value={yeguere}
              onChange={(e) => setYeguere(e.target.value)}
              placeholder="Yeguere"
            />
          </Col>

          <Col md={3} xs={12} sm={12} lg={3} className="d-grid">
            <button
              className="btn btn-primary"
              onClick={() => inserNewYeguere()}
            >
              <i>
                <FontAwesomeIcon icon="fa-solid fa-plus" />
              </i>{" "}
              Agregar
            </button>
          </Col>
        </Row>
        <br />
        <Row>
          <Col>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Yeguere</th>
                  <th>Acción</th>
                </tr>
              </thead>
              <tbody>
                {yegeuereList.map((item, i) => (
                  <tr key={item.idyeguere}>
                    <th>{item.yeguere}</th>
                    <td>
                      <button
                        className="btn btn-outline-primary"
                        onClick={() => editYeguere(item.idyeguere)}
                      >
                        <FontAwesomeIcon icon="fa-solid fa-pencil" />
                      </button>{" "}
                      <button
                        className={
                          item.estatus === 1
                            ? "btn btn-outline-danger"
                            : "btn btn-outline-success"
                        }
                        onClick={() =>
                          deleteYeguere(item.idyeguere, item.estatus)
                        }
                      >
                        <FontAwesomeIcon icon="fas fa-power-off" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Yeguere;
